import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text = 'Loading...',
  fullPage = false,
}) => {
  const spinnerSize = size === 'sm' ? 'spinner-border-sm' : '';

  if (fullPage) {
    return (
      <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ zIndex: 1050 }}>
        <div className="text-center">
          <div className={`spinner-border ${spinnerSize} text-primary`} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          {text && <p className="mt-3 fw-medium" style={{ color: '#000537', fontSize: '0.875rem' }}>{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-4">
      <div className={`spinner-border ${spinnerSize} text-primary`} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {text && <p className="mt-2" style={{ color: '#71717a', fontSize: '0.875rem' }}>{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
